
import { Injectable } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: "root" })
export class DashboardService {

    constructor(private translate: TranslateService) {

    }

    public getMonths(): any[] {
        return [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ];
    }

    public getLocalizedMonths(): any[] {
        return [
            this.translate.instant('JANUARY'),
            this.translate.instant('FEBRUARY'),
            this.translate.instant('MARCH'),
            this.translate.instant('APRIL'),
            this.translate.instant('MAY'),
            this.translate.instant('JUNE'),
            this.translate.instant('JULY'),
            this.translate.instant('AUGUST'),
            this.translate.instant('SEPTEMBER'),
            this.translate.instant('OCTOBER'),
            this.translate.instant('NOVEMBER'),
            this.translate.instant('DECEMBER')
          ];
    }

    public isPeriodByDate(fromDate, toDate): boolean {
        const diff = Math.abs(toDate.getTime() - fromDate.getTime());
        const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        return diffDays < 31;
    }
}
